
interface StatusBadgeProps {
  value: number | string | undefined;
  type: "payment" | "order" | "priority";
}


/** Cancelled — same numeric code used when hiding pay on public order summary. */
export const SALES_ORDER_CANCELLED_STATUS_CODE = 400;

/** Confirmed — order already finalized; public summary should show Pay (not Approve) for balance due. */
export const SALES_ORDER_CONFIRMED_STATUS_CODE = 101;

// ✅ Status Map for Order (numeric codes) — colors from your spec
export const STATUS_MAP: Record<number, { bg: string; color: string; label: string }> = {
  100: { bg: "#e5e7eb", color: "#4b5563", label: "Draft" },
  101: { bg: "#E6F9E6", color: "#2b6825", label: "Confirmed" },
  300: { bg: "#cfe8fc", color: "#276ada", label: "Ready To Pickup" },
  301: { bg: "#cfe8fc", color: "#276ada", label: "Shipped" },
  302: { bg: "#d2f5d2", color: "#368727", label: "Delivered" },
  400: { bg: "#fddede", color: "#d93025", label: "Cancelled" },
  401: { bg: "#d2f5d2", color: "#2a6b2a", label: "Completed" },
};

// ✅ Payment Status (by name/label)
const paymentStatusColors: Record<string, { bg: string; color: string }> = {
  "Partial Payment": { bg: "#ffeacc", color: "#cc8400" },
  "Paid": { bg: "#d2f5d2", color: "#2a6b2a" },
  "Pending": { bg: "#ffe0b3", color: "#b76b00" },
  "Overpaid": { bg: "#e0cfff", color: "#6b21a8" },
  "Overdue": { bg: "#ffe2e2", color: "#9f0712" },
};

// ✅ Order Status (by name/label)
const orderStatusColors: Record<string, { bg: string; color: string }> = {
  Draft: { bg: "#e5e7eb", color: "#4b5563" },
  Quote: { bg: "#e5e7eb", color: "#4b5563" },
  Confirmed: { bg: "#fff7c2", color: "#a6b800" },
  Shipped: { bg: "#cfe8fc", color: "#276ada" },
  Cancelled: { bg: "#fddede", color: "#d93025" },
  Delivered: { bg: "#d2f5d2", color: "#368727" },
  Completed: { bg: "#d2f5d2", color: "#2a6b2a" },
  "Partial Payment": { bg: "#ffeacc", color: "#cc8400" }, // if ever shown under order type
  Paid: { bg: "#d2f5d2", color: "#2a6b2a" },
  Pending: { bg: "#ffe0b3", color: "#b76b00" },
  Overpaid: { bg: "#e0cfff", color: "#6b21a8" },
  Overdue: { bg: "#ffe2e2", color: "#9f0712" },
  Finalized: { bg: "#d9f2ff", color: "#2563eb" },
  Scheduled: { bg: "#e0f7fa", color: "#00838f" },
  "In-Progress": { bg: "#ffe3c7", color: "#92400e" },
  Lost: { bg: "#fcdcdc", color: "#b91c1c" },
  Active: { bg: "#d2f5d2", color: "#2a6b2a" },
  Inactive: { bg: "#e5e7eb", color: "#4b5563" },
};

// ✅ Priority Colors (by label)
const priorityColors: Record<string, { bg: string; color: string }> = {
  "High": { bg: "#ffe0e0", color: "#d93025" },
  "Medium": { bg: "#e0f0ff", color: "#276ada" },
  "Low": { bg: "#d2f5d2", color: "#368727" },
};

// ✅ Base badge (no font-weight, 8px radius, 6px padding — outline set per instance)
const BASE_BADGE_STYLE: React.CSSProperties = {
  display: "inline-block",
  padding: "3px 7px",
  borderRadius: "0.525rem",
  fontSize: " 0.75rem",          // keep or tweak; no font weight
  textAlign: "center",
};


export const SalesOrderStatusBadge: React.FC<StatusBadgeProps> = ({ value, type }) => {
  if (value === undefined || value === null || value === "") return <span>—</span>;

  let bgColor = "#E2E3E5";
  let textColor = "#383D41";
  let label = typeof value === "string" ? value : "";

  if (type === "payment" && typeof value === "string") {
    const c = paymentStatusColors[value];
    if (c) { bgColor = c.bg; textColor = c.color; }
  } else if (type === "order") {
    if (typeof value === "number") {
      const s = STATUS_MAP[value];
      if (s) { label = s.label; bgColor = s.bg; textColor = s.color; }
    } else if (typeof value === "string") {
      const orderLabel = value === "Quote" ? "Draft" : value;
      label = orderLabel;
      const c = orderStatusColors[orderLabel];
      if (c) { bgColor = c.bg; textColor = c.color; }
    }
  } else if (type === "priority" && typeof value === "string") {
    const c = priorityColors[value];
    if (c) { bgColor = c.bg; textColor = c.color; }
  }

  const style: React.CSSProperties = {
    ...BASE_BADGE_STYLE,
    backgroundColor: bgColor,
    color: textColor,
    border: "0.2px solid",
    borderColor: `${textColor}50`,
  };

  return <div style={style}>{label}</div>;
};















// import React from "react";

// // ✅ Status Map for Order
// export const STATUS_MAP: Record<number, { bg: string; color: string; label: string }> = {
//   100: { bg: "#D3D3D3", color: "#000000", label: "Draft" },
//   101: { bg: "#fbedbe", color: "#856404", label: "Confirmed" },
//   300: { bg: "#BEE5EB", color: "#0C5460", label: "Shipping" },
//   301: { bg: "#BEE5EB", color: "#0C5460", label: "Shipped" },
//   302: { bg: "#C3E6CB", color: "#155724", label: "Delivered" },
//   400: { bg: "#F8D7DA", color: "#721C24", label: "Cancelled" },
//   401: { bg: "#fbedbe", color: "#856404", label: "Completed" },
// };

// // ✅ Priority labels
// export const PRIORITY_LABELS: { [key: number]: string } = {
//   1: "High",
//   2: "Medium",
//   3: "Low",
// };

// // ✅ Payment Status Colors
// const paymentStatusColors: Record<string, { bg: string; color: string }> = {
//   "Partial Payment": { bg: "#FFF3CD", color: "#856404" },
//   "Paid": { bg: "#D4EDDA", color: "#155724" },
//   "Pending": { bg: "#F8D7DA", color: "#721C24" },
//   "Overpaid": { bg: "#f5ea73", color: "#414039" }, // ✅ Fixed double ## bug
// };

// // ✅ Order Status Colors
// const orderStatusColors: Record<string, { bg: string; color: string }> = {
//   Draft: { bg: "#D3D3D3", color: "#000000" },
//   Finalized: { bg: "#CCE5FF", color: "#004085" },
//   Scheduled: { bg: "#B8DAFF", color: "#004085" },
//   "In Progress": { bg: "#FFF3CD", color: "#856404" },
//   Completed: { bg: "#C3E6CB", color: "#155724" },
//   Cancelled: { bg: "#F8D7DA", color: "#721C24" },
//   Losted: { bg: "#f8949e", color: "#3a3a3a" },
// };

// // ✅ Priority Colors
// const priorityColors: Record<string, { bg: string; color: string }> = {
//   High: { bg: "#F6C6C7", color: "#842029" },
//   Medium: { bg: "#FFD966", color: "#7A6000" },
//   Low: { bg: "#D9EAD3", color: "#274E13" },
// };

// // ✅ Base Styles
// const paymentBaseStyle = {
//   display: "inline-block",
//   padding: "4px 12px",
//   fontSize: "14.5px",
//   fontWeight: 500,
//   borderRadius: "20px",
//   border: "1px solid transparent",
//   textAlign: "center" as const,
// };

// const orderBaseStyle = {
//   fontSize: "13px",
//   padding: "6px 14px",
//   borderRadius: "10px",
//   display: "inline-block",
//   fontWeight: 500,
//   textAlign: "center" as const,
// };

// const priorityBaseStyle = {
//   fontSize: "13px",
//   padding: "6px 12px",
//   borderRadius: "6px",
//   display: "inline-block",
//   fontWeight: 500,
//   textAlign: "center" as const,
// };

// // ✅ Component Props
// interface StatusBadgeProps {
//   value: number | string | undefined;
//   type: "payment" | "order" | "priority";
// }

// // ✅ Status Badge Component
// export const SalesOrderStatusBadge: React.FC<StatusBadgeProps> = ({ value, type }) => {
//   if (value === undefined || value === null || value === "") {
//     return <span>—</span>;
//   }

//   let bgColor = "#E2E3E5";
//   let textColor = "#383D41";
//   let label = "";

//   if (type === "payment" && typeof value === "string") {
//     label = value;
//     const colors = paymentStatusColors[value];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   } else if (type === "order" && typeof value === "number") {
//     const statusObj = STATUS_MAP[value];
//     label = statusObj ? statusObj.label : "Unknown";
//     if (statusObj) {
//       bgColor = statusObj.bg;
//       textColor = statusObj.color;
//     }
//   } else if (type === "priority" && typeof value === "string") {
//     label = value;
//     const colors = priorityColors[value];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   }

//   const style =
//     type === "payment"
//       ? { ...paymentBaseStyle, backgroundColor: bgColor, color: textColor }
//       : type === "order"
//       ? { ...orderBaseStyle, backgroundColor: bgColor, color: textColor }
//       : { ...priorityBaseStyle, backgroundColor: bgColor, color: textColor };

//   return <div style={style}>{label}</div>;
// };






















// import React from "react";

// // Maps for status and priority labels
// export const STATUS_MAP: { [key: number]: string } = {
//   100: "Draft",
//   101: "Confirmed",
//   // 200: "Finalized",
//   300: "Shipping",
//   301: "Shipped",
//   302: "Delivered",
//   400: "Cancelled",
//   401: "Completed",
//   // 500: "Completed",
//   // 600: "Cancelled",
//   // 700: "Lost",
// };

// export const PRIORITY_LABELS: { [key: number]: string } = {
//   1: "High",
//   2: "Medium",
//   3: "Low",
// };

// // Color styles for Payment Status
// const paymentStatusColors: Record<string, { bg: string; color: string }> = {
//   "Partial Payment": { bg: "#FFF3CD", color: "#856404" }, // Payment Pending style
//   "Paid": { bg: "#D4EDDA", color: "#155724" },            // Payment Accepted style
//   "Pending": { bg: "#FFF3CD", color: "#856404" },         // Payment Pending style
// };

// // Color styles for Order Status
// const orderStatusColors: Record<string, { bg: string; color: string }> = {
//   Draft: { bg: "#D3D3D3", color: "#000000" },
//   Finalized: { bg: "#CCE5FF", color: "#004085" },
//   Scheduled: { bg: "#B8DAFF", color: "#004085" },
//   "In Progress": { bg: "#FFF3CD", color: "#856404" },
//   Completed: { bg: "#C3E6CB", color: "#155724" },
//   Cancelled: { bg: "#F8D7DA", color: "#721C24" },
//   Losted: { bg: "#f8949eff", color: "#3a3a3aff" },
// };

// // Color styles for Priority
// const priorityColors: Record<string, { bg: string; color: string }> = {
//   High: { bg: "#F6C6C7", color: "#842029" },
//   Medium: { bg: "#FFD966", color: "#7A6000" },
//   Low: { bg: "#D9EAD3", color: "#274E13" },
// };

// const paymentBaseStyle = {
//   display: "inline-block",
//   padding: "4px 12px",
//   fontSize: "14.5px",
//   fontWeight: 500,
//   borderRadius: "20px",
//   border: "1px solid transparent",
//   textAlign: "center" as const,
// };

// const orderBaseStyle = {
//   fontSize: "13px",
//   padding: "6px 14px",
//   borderRadius: "10px",
//   display: "inline-block",
//   fontWeight: 500,
//   textAlign: "center" as const,
// };

// const priorityBaseStyle = {
//   fontSize: "13px",
//   padding: "6px 12px",
//   borderRadius: "6px",
//   display: "inline-block",
//   fontWeight: 500,
//   textAlign: "center" as const,
// };

// // StatusBadge component props
// interface StatusBadgeProps {
//   value: number | string | undefined;
//   type: "payment" | "order" | "priority";
// }

// export const SalesOrderStatusBadge: React.FC<StatusBadgeProps> = ({ value, type }) => {
//   if (value === undefined || value === null || value === "") {
//     return <span>—</span>;
//   }

//   let bgColor = "#E2E3E5";
//   let textColor = "#383D41";
//   let label = "";

//   if (type === "payment" && typeof value === "string") {
//     label = value;
//     const colors = paymentStatusColors[value];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   } else if (type === "order" && typeof value === "number") {
//     label = STATUS_MAP[value] || "Unknown";
//     const colors = orderStatusColors[label];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   } else if (type === "priority" && typeof value === "string") {
//     label = ` ${value}`;
//     const colors = priorityColors[value];
//     if (colors) {
//       bgColor = colors.bg;
//       textColor = colors.color;
//     }
//   }

//   const style =
//     type === "payment"
//       ? { ...paymentBaseStyle, backgroundColor: bgColor, color: textColor }
//       : type === "order"
//       ? { ...orderBaseStyle, backgroundColor: bgColor, color: textColor }
//       : { ...priorityBaseStyle, backgroundColor: bgColor, color: textColor };

//   return <div style={style}>{label}</div>;
// };
